// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"7734802f","663":"fbed2dd4","766":"7734802f"}[chunkId] + ".chunk.css";
};